module.exports = __webpack_public_path__ + "img/s1.a3fb84d1.png";